import React from 'react';
import { Link } from 'react-router-dom';
import { navigationLinks, adjacencyPages, legalLinks, partnerFirms } from '../data/siteContent';

export default function Footer() {
  return (
    <footer className="bg-charcoal text-gray-200 py-16 px-6">
      <div className="max-w-6xl mx-auto grid gap-10 md:grid-cols-4">
        <div>
          <h3 className="text-lg font-semibold text-white mb-4">Navigation</h3>
          <ul className="space-y-2 text-sm">
            {navigationLinks.map((link) => (
              <li key={link.path}>
                <Link to={link.path} className="text-gray-300 hover:text-white">
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="text-lg font-semibold text-white mb-4">Connect</h3>
          <ul className="space-y-2 text-sm">
            {adjacencyPages.map((link) => (
              <li key={link.path}>
                <Link to={link.path} className="text-gray-300 hover:text-white">
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="text-lg font-semibold text-white mb-4">Legal</h3>
          <ul className="space-y-2 text-sm">
            {legalLinks.map((link) => (
              <li key={link.path}>
                <Link to={link.path} className="text-gray-300 hover:text-white">
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="text-lg font-semibold text-white mb-4">Partner Spotlight</h3>
          <ul className="space-y-3 text-sm">
            {partnerFirms.map((partner) => (
              <li key={partner.name}>
                <p className="text-white font-semibold">{partner.name}</p>
                <p className="text-gray-400 text-xs">{partner.description}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10 mt-10 pt-6 text-center text-gray-400 text-xs">
        &copy; {new Date().getFullYear()} Tax Strategy Center. All rights reserved. Built with compliance-first principles.
      </div>
    </footer>
  );
}
